import { gql } from '@apollo/client';

export const deleteResource_Name = 'DeleteResource';
export const deleteResource_Gql = gql`
  mutation DeleteResource($resourceId: String!) {
    deleteResource(resourceId: $resourceId)
  }
`;
